const CommonReducer = (state = { noticeList: [] }, action) => {
    switch (action.type) {
        case "GET_NOTICE_LIST":
            return {
                ...state,
                noticeList: action.data
            }
        case "SEARCH_INTEROFFICE_MESSAGE":
            return {
                ...state,
                interOfficeMessageList: action.data
            }
        case "INTEROFFICE_MESSAGE_FILTER":
            return {
                ...state,
                interOfficeMessageFilters: action.data
            }
        default:
            return state;
    }
}
export default CommonReducer;